import React from 'react';
import { RadioGroupProvider } from '../../../context';
import { ReportEventFormRadios } from './ReportEventFormRadios';

export const RadioGroup = (props: {
    children: React.ReactNode;
    defaultSelection?: string;
    country: string;
    userCountry: string;
}) => {
    const { children, defaultSelection, country, userCountry } = props;

    return (
        <RadioGroupProvider selection={defaultSelection}>
            <ReportEventFormRadios
                country={country}
                userCountry={userCountry}
            />
            {children}
        </RadioGroupProvider>
    );
};
